import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpCustomerService} from '../../../../service/httpcustomer.service';
import {WebParameterContext} from '../../../../model/common';
import {GridBaseCase} from '../grid.base.case';
import {HandleWebParameterContextBeforeDBRequest,HandleServerContextAfterDBRequest} from '../../../../bizlogic/servicesbll';
import { MessageclientService } from 'src/service/messageclient.service';
import { CommonService } from 'src/service/common.service';

declare var app;
@Component({
  selector: 'app-mz-grid-list-head',
  templateUrl: './mz-grid-list-head.component.html',
  styleUrls: ['./mz-grid-list-head.component.scss']
})
export class MzGridListHeadComponent extends GridBaseCase {
  public Statas:any = [];
  constructor(
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private msg:MessageclientService,
    private router:Router,
    private com: CommonService
  ) { super();
  }
 /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    this.LoadData();
    event.target.complete();
  }
  LoadData(){
    const that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.Account = that.com.GetAccount;
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }

    body = HandleWebParameterContextBeforeDBRequest(body);
    if(!body.ResponseMessage.Success){
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    
    that.http.post(app.DEFAULTURL, body).then(data => {
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      data = HandleServerContextAfterDBRequest(body,data);
      that.Statas = [];
      if (data.ResponseMessage.Success) {
        // that.Statas=data.Status.Datas;
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
            if (element.bindingField == 'date' && item[element.field]) {
              objfield[element.bindingField] = item[element.field].replace('00:00:00','');
            }
          });
          that.Statas.push(objfield);
        });
      }
    }).catch(error => {
      console.log(error);
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
    })
  }
  ngAfterContentInit() {
   this.LoadData();
  }
  // EventLink(url,id){
  //   console.log(url,id);
  //   if (url && id) {
  //       this.router.navigateByUrl(url + "/" +id);
  //   }
  // }

  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        console.log(evs, parms);
      } else {
        // localStorage.setItem('element', JSON.stringify(ev));
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/" + parms.id);
        this.com.Go(evs + "/" + parms.id);
      }
    }
  }

}
